import { useEffect, useState } from 'react';
/**
 * Sleduje stav načítání VectorTileLayer a vrací loading: boolean
 */
export function useVectorTileLayerLoading(layer) {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!layer) {
            setLoading(false);
            return;
        }
        const source = layer.getSource();
        if (!source) {
            setLoading(false);
            return;
        }
        let loadingCount = 0;
        const handleLoadStart = () => {
            loadingCount++;
            setLoading(true);
        };
        const handleLoadEnd = () => {
            loadingCount = Math.max(0, loadingCount - 1);
            if (loadingCount === 0) {
                setLoading(false); // všechno načteno
            }
        };
        source.on('tileloadstart', handleLoadStart);
        source.on('tileloadend', handleLoadEnd);
        source.on('tileloaderror', handleLoadEnd);
        return () => {
            source.un('tileloadstart', handleLoadStart);
            source.un('tileloadend', handleLoadEnd);
            source.un('tileloaderror', handleLoadEnd);
        };
    }, [layer]);
    return loading;
}
//# sourceMappingURL=useVectorTileLayerLoading.js.map